import storageManager from '@/api/storageManager';

export const REGISTRATION_SOURCE = {
	STUDIO: 'studio',
	CHAT: 'chat',
	TOP: 'top',
};

const PLATFORM_UTM_PREFIX = 'platform_';

const UTM_DEFAULTS = {
	SOURCE: 'PLATFORM',
	MEDIUM: 'APP',
};

const PATH_PREFIXES = {
	STUDIO: '/studio',
	CHAT: '/chat',
};

export const getStoredUtms = () => {
	const utms = storageManager.utm.get();

	return Object.entries(utms).reduce((acc, [key, value]) => {
		if (value !== null && value !== undefined) {
			acc[key] = value;
		}
		return acc;
	}, {});
};

export const getPaymentUtms = () => {
	const utms = getStoredUtms();
	const { sk: _sk, ...utmFields } = utms;

	return {
		...utmFields,
		utm_source: utmFields.utm_source || UTM_DEFAULTS.SOURCE,
		utm_medium: utmFields.utm_medium || UTM_DEFAULTS.MEDIUM,
	};
};

export const getMailLinkKey = () => {
	const utms = getStoredUtms();
	return utms.sk || undefined;
};

export const getRegistrationUtms = (registrationSource, returnPath) => {
	const stored = getStoredUtms();

	if (stored.utm_source) {
		return stored;
	}

	const source =
		registrationSource ||
		inferRegistrationSourceFromPath(returnPath) ||
		inferRegistrationSourceFromPath(
			typeof window !== 'undefined' ? window.location.pathname : '',
		);

	if (!source) {
		return stored;
	}

	return {
		...stored,
		utm_source: `${PLATFORM_UTM_PREFIX}${source}`,
	};
};

const inferRegistrationSourceFromPath = (path) => {
	if (!path) {
		return null;
	}

	if (path.startsWith(PATH_PREFIXES.STUDIO)) {
		return REGISTRATION_SOURCE.STUDIO;
	}

	if (path.startsWith(PATH_PREFIXES.CHAT)) {
		return REGISTRATION_SOURCE.CHAT;
	}

	return null;
};

const MONGO_OBJECT_ID_PATTERN = /^[a-fA-F0-9]{24}$/;

export const getBrowsingPersonId = () => {
	return storageManager.utm.getBrowsingPersonId();
};

export const getPaymentBrowsingPersonId = () => {
	const browsingPersonId = getBrowsingPersonId();

	if (!browsingPersonId || !MONGO_OBJECT_ID_PATTERN.test(browsingPersonId)) {
		return undefined;
	}

	return browsingPersonId;
};

export const isQuizPaymentContext = () => {
	if (getPaymentBrowsingPersonId()) {
		return true;
	}

	const { utm_source: utmSource } = getStoredUtms();
	if (!utmSource) {
		return false;
	}

	return !utmSource.startsWith(PLATFORM_UTM_PREFIX);
};
